import { InterestAccountRequest, InterestAccount } from 'vopay';

import axios from 'axios';
import { api } from '@/services/api.config';
import { useState } from 'react';

export default function useFetchInterestAccounts() {
  const [fetchingInterestAccounts, setFetchingInterestAccounts] = useState(false);
  const [interestAccounts, setInterestAccounts] = useState<InterestAccount[]>([]);

  const source = axios.CancelToken.source();

  async function fetchInterestAccounts(requestParams: InterestAccountRequest) {
    try {
      setFetchingInterestAccounts(true);
      const res = await api.fetchInterestAccount(requestParams, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setInterestAccounts(res.InterestAccounts);

      return res.InterestAccounts;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingInterestAccounts(false);
    }
  }

  return {
    interestAccounts,
    fetchInterestAccounts,
    fetchingInterestAccounts,
  };
}
